import { render, staticRenderFns } from "./PatientReschedule.vue?vue&type=template&id=79611196&scoped=true&"
import script from "./PatientReschedule.vue?vue&type=script&lang=js&"
export * from "./PatientReschedule.vue?vue&type=script&lang=js&"
import style0 from "./PatientReschedule.vue?vue&type=style&index=0&id=79611196&prod&lang=scss&scoped=true&"
import style1 from "./PatientReschedule.vue?vue&type=style&index=1&id=79611196&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79611196",
  null
  
)

export default component.exports